// import dateFormat, { formatDateTime } from "../../../../../utils/dateFormat";

// export const accessHistoryHeader = [
//   "Affiliate",
//   "Branch",
//   "Username",
//   "Full Name",
//   "Search Date",
//   "LOCK(Y/N)",
// ];

// export const accessHistoryBody = (accessHistory, object) => {
//   const lockedUsername = object?.lockedTo?.username?.trim()?.toLowerCase();
//   const accessHistoryBody = accessHistory.map((history) => {
//     // console.log("HISTORY", history);
//     const { accessor } = history || {};

//     const dateDisplay = history?.searchDT
//       ? formatDateTime(history.searchDT)
//       : dateFormat(history.createdAt);

//     return [
//       accessor.affiliate.name,
//       accessor.branch.name,
//       accessor.username,
//       `${accessor?.firstName} ${accessor?.middleName} ${accessor?.lastName}`,
//       // formatDateTime(history?.searchDT) || dateFormat(history.createdAt),
//       dateDisplay,
//       "",
//     ];
//   });

//   return accessHistoryBody;
// };
// import dateFormat, { formatDateTime } from "../../../../../utils/dateFormat";

// export const accessHistoryHeader = [
//   "Affiliate",
//   "Branch",
//   "Username",
//   "Full Name",
//   "Search Date",
//   "LOCK(Y/N)",
// ];

// export const accessHistoryBody = (accessHistory = [], object = {}) => {
//   const lockedUsername = object?.lockedTo?.username?.trim()?.toLowerCase();

//   return accessHistory.map((history) => {
//     const { accessor = {} } = history || {};

//     const dateDisplay = history?.searchDT
//       ? formatDateTime(history.searchDT)
//       : dateFormat(history.createdAt);

//     const accessorUsername = accessor?.username?.trim()?.toLowerCase();

//     const lockStatus =
//       lockedUsername && accessorUsername === lockedUsername ? "Y" : "N";

//     const fullName = [
//       accessor?.firstName,
//       accessor?.middleName,
//       accessor?.lastName,
//       // accessor?.alias,
//     ]
//       .filter(Boolean)
//       .join(" ");

//     return [
//       accessor?.affiliate?.name || "",
//       accessor?.branch?.name || "",
//       accessor?.username || "",
//       fullName,
//       dateDisplay,
//       lockStatus,
//     ];
//   });
// };

import dateFormat, { formatDateTime } from "../../../../../utils/dateFormat";

export const accessHistoryHeader = [
  "Affiliate",
  "Branch",
  "Username",
  "Full Name",
  "Search Date",
  "LOCK(Y/N)",
];

export const accessHistoryBody = (accessHistory = [], object = {}) => {
  console.log("vvv", accessHistory);
  const lockedUsername = object?.lockedTo?.username?.trim()?.toLowerCase();

  // Step 1: find the index of the LATEST entry that matches the locked username
  let latestMatchIndex = -1;
  let latestTime = -Infinity;

  if (lockedUsername) {
    accessHistory.forEach((history, idx) => {
      const accessor = history?.accessor || {};
      const accessorUsername = accessor?.username?.trim()?.toLowerCase();

      if (accessorUsername === lockedUsername) {
        const rawDate = history?.searchDT || history?.createdAt;
        const time = rawDate ? new Date(rawDate).getTime() : 0;

        if (time > latestTime) {
          latestTime = time;
          latestMatchIndex = idx;
        }
      }
    });
  }

  // Step 2: build rows, only the latestMatchIndex gets "Y"
  return accessHistory.map((history, idx) => {
    const { accessor = {}, lockStatus } = history || {};

    console.log("asas", accessor);

    const dateDisplay = history?.searchDT
      ? formatDateTime(history.searchDT)
      : dateFormat(history.createdAt);

    // const lockStatus = idx === latestMatchIndex ? "Y" : "N";

    const fullName = [
      accessor?.firstName,
      accessor?.middleName,
      accessor?.lastName,
      // accessor?.alias,
    ]
      .filter(Boolean)
      .join(" ");

    return [
      accessor?.affiliate?.name || "",
      accessor?.branch?.name || "",
      accessor?.username || "",
      fullName,
      dateDisplay,
      lockStatus,
    ];
  });
};
